import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/Florida.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose TekRevol for Software Development in Florida?</h2>
            <p>
              Choosing the right software development partner is a critical
              decision for your business, and TekRevol is the best choice in the
              Florida market.
            </p>
            <p>
              With a commitment to innovation, industry expertise, and a proven
              track record, we stand as the premier option for software
              development.
            </p>
            <p>
              Our team's dedication to understanding your unique requirements
              and delivering customized software solutions sets us apart. By
              choosing TekRevol, you are opting for a trusted ally committed to
              turning your vision into a digital reality.
            </p>
            <p>
              We leverage the latest technologies to drive your business forward
              in the Sunshine State, making us the optimal choice for your
              software development needs in Florida.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
